const s={MissingConsentPayload:"MISSING_MARKERTING_CONSENT_PAYLOAD"},b={Subscribed:"subscribed",NotSubscribed:"not_subscribed",Unsubscribed:"unsubscribed"};export{s as UnlikelyCustomerErrors,b as UnlikelyMarketingState};
//# sourceMappingURL=customers.js.map
